import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { selectWorks, selectWork } from '../../../Api/selectors';
import { selectNewCompany } from '../../selectors';
import {
  setNewCompanyValue,
  initiateCompanyCreate,
  createCompany,
  addUserToCompany,
  toggleNotification,
} from '../../actions';
import { selectAddressTypes } from '../../../Address/selectors';
import { CompanyQuickCreatorMobileModal } from './QuickCreatorMobileModal';
import { CompanyQuickCreatorModal } from './QuickCreatorModalComponent';
import {
  REQUEST_COMPANY,
  COMPANY_QUICK_CREATE_FIELDS,
  REQUEST_COUNTRIES,
  REQUEST_COMPANIES_CREATE,
  REQUEST_COMPANY_ADD_USER,
} from '../../constants';
import { checkUserEmail, createUser } from '../../../Users/actions';
import { UserQuickCreator } from '../../../Users/pages/QuickCreate';
import { setNewOrderValue, setNewVehicleValue } from '../../../Vehicles/actions';
import { CREATE_USER } from '../../../Users/constants';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

const Container = styled.div`
  z-index: ${props => {
    if ((props.outgoingModal || props.incomingModal) && props.innerWidth <= 768) {
      return '102';
    }
    if (props.outgoingModal || props.incomingModal) {
      return '10000';
    }
  }};
  position: ${props => (props.outgoingModal || props.incomingModal ? 'fixed' : '')};
  left: 0;
  top: 68px;
`;

const STATE = {
  addresses: [],
  stepperClickStep: null,
  stepperClick: false,
  duplicateUser: [],
};

const resetValuesArray = [
  ...COMPANY_QUICK_CREATE_FIELDS,
  'relation_financial_contact_id',
  'relation_commercial_contact_id',
  'relation_vehicle_documents_contact_id',
];

/* eslint-disable react/prefer-stateless-function */
class CompanyQuickCreatorComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
  }

  toggleUserModal() {
    this.setState({ showUserModal: true });
  }

  createUser(options, callback) {
    let userDto = {};
    if (this.props.values?.company_type == 'individual') {
      userDto = {
        email_address: this.props.values?.email || '',
        password: '',
        properties: [
          { name: 'name', value: this.props.values?.name || '' },
          { name: 'surname', value: this.props.values?.surname || '' },
        ],
      };

      if (this.props.values?.email) {
        if (options == 'no') {
          this.setState({ duplicateUser: [] });
          return;
        }

        if (options?.id) {
          this.props.setValue(options?.id, 'contact');
          this.setState({ duplicateUser: [] });
          return callback();
        }

        this.props.checkEmail(this.props.values?.email, result => {
          if (result?.items?.length) {
            this.setState({ duplicateUser: result?.items });
            return;
          }

          this.props.createUser(userDto, result => {
            if (result?.id) {
              this.props.setValue(result?.id, 'contact');
              return callback();
            }
          });
        });
      }
    }
  }

  save(callback) {
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };
    const requestBodyTypes = { addressLine1: '', postcode: '', city: '', countryId: '', accountManagerId: '' };
    let addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    let newAddress = {};
    let isRoleselected =
      this.props.values?.relation_financial_contact_id ||
      this.props.values?.relation_commercial_contact_id ||
      this.props.values?.relation_vehicle_documents_contact_id;

    let prop = {
      properties: [{ name: 'status', value: '0' }],
      addresses: [],
      accountManagerId: this.props.values.accountManagerId || null,
    };

    for (let i in this.props.values) {
      if (
        i == 'contact' &&
        this.props.values[i] &&
        (this.props.values?.company_type == 'individual' ||
          (this.props.values?.company_type == 'company' && !isRoleselected))
      ) {
        prop.properties.push({
          name: 'relation_commercial_contact_id',
          value: this.props.values[i],
        });
        prop.properties.push({
          name: 'relation_vehicle_documents_contact_id',
          value: this.props.values[i],
        });
        prop.properties.push({
          name: 'relation_financial_contact_id',
          value: this.props.values[i],
        });
      }
      if (this.props.values[i] != '' && i != 'addresses' && !Object.keys(requestBodyTypes).includes(i)) {
        this.props.values[i] &&
          prop.properties.push({
            name: i,
            value: this.props.values[i],
          });
      }
    }

    if (env.clientId === AppClientId.AUTOWIENTJES) {
      prop.properties.push({
        name: 'language',
        value: 'NL',
      });
    }

    for (let i in addressProps) {
      if (this.props.values[i] != '') {
        newAddress[i] = this.props.values[i];
        newAddress['typeId'] = addressTypeId;
      }
    }

    let addresses = [];
    try {
      Object.keys(newAddress).length > 1 ? (addresses = [newAddress]) : null;
    } catch (e) {}
    this.props.create(prop.properties, addresses, prop.accountManagerId, [], result => {
      if (result?.id) {
        !this.props.values?.contact && this.props.toggleNotification('success');
        if (this.props.userDetails) {
          this.props.onSelect(result);
          this.props.resetValues(resetValuesArray);
          return;
        }
        if (this.props.values?.contact) {
          this.props.addUserToCompany(result?.id, this.props.values?.contact, res => {
            if (res?.id) {
              this.props.toggleNotification('success');
              !this.props.incomingModal && !this.props.outgoingModal ? this.to(`/companies/${result.id}`) : null;
              !this.props.incomingModal && !this.props.outgoingModal ? this.props.resetValues(resetValuesArray) : null;
              if (this.props.incomingModal) {
                this.props.setNewVehicleValue(result.id, 'creditor_company');
                this.props.resetQuickModal();
              }
              if (this.props.outgoingModal) {
                this.props.setNewOrderValue(result.id, 'outgoingCompanyId');
                this.props.resetQuickModal();
              }
            }
          });

          return;
        }

        this.props.resetValues(resetValuesArray);
        if (this.props.outgoingModal) {
          this.props.setNewOrderValue(result.id, 'outgoingCompanyId');
        }
        if (this.props.incomingModal) {
          this.props.setNewVehicleValue(result.id, 'creditor_company');
        }
        return this.props.outgoingModal || this.props.incomingModal ? this.reset() : this.to(`/companies/${result.id}`);
      }
    });
  }

  reset() {
    this.props.resetValues(resetValuesArray);
    this.setState({ ...STATE });
    this.props.resetQuickModal();
  }

  render() {
    return (
      <Container
        innerWidth={window.innerWidth}
        outgoingModal={this.props.outgoingModal}
        incomingModal={this.props.incomingModal}
      >
        {this.state.showUserModal && (
          <UserQuickCreator forNewCompany reset={() => this.setState({ showUserModal: false })} />
        )}
        <CompanyQuickCreatorModal
          fields={COMPANY_QUICK_CREATE_FIELDS}
          onShowUserModal={this.toggleUserModal.bind(this)}
          workCreate={this.props.workCreate}
          duplicateUser={this.state.duplicateUser}
          onSave={
            this.props.values?.company_type == 'individual'
              ? options => this.createUser(options, this.save.bind(this))
              : this.save.bind(this)
          }
          onCancel={this.reset.bind(this)}
        />
      </Container>
    );
  }
}

CompanyQuickCreatorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY, REQUEST_COUNTRIES]),
    workCreate: selectWorks([REQUEST_COMPANIES_CREATE, CREATE_USER, REQUEST_COMPANY_ADD_USER]),
    values: selectNewCompany(),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateCompanyCreate());
    },
    create(properties, addresses, accountManagerId, options, callback) {
      dispatch(createCompany(properties, addresses, accountManagerId, options, callback));
    },
    createUser(userDto, callback) {
      dispatch(createUser(userDto, callback));
    },
    setValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },
    setNewOrderValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewOrderValue(name, value));
    },
    setNewVehicleValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewVehicleValue(name, value));
    },
    addUserToCompany(companyId, userId, callback) {
      dispatch(addUserToCompany(companyId, userId, callback));
    },
    resetValues(values) {
      values.map(type => dispatch(setNewCompanyValue(type, '')));
    },
    toggleNotification(message) {
      dispatch(toggleNotification('1', message));
    },
    checkEmail(email_address, callback) {
      dispatch(checkUserEmail(email_address, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyQuickCreator = compose(withConnect, withRouter)(CompanyQuickCreatorComp);
